import axios from 'axios';
import { Config } from 'config';
import { getAccessToken } from 'lib/Helper/Auth';
import { FeedbackSubmission, FeedbackResponse } from 'lib/Model/Feedback';

export function submitFeedback(
  feedback: FeedbackSubmission,
): Promise<FeedbackResponse> {
  return axios
    .post(`${Config.API_BASE_URL}intranet/submit-feedback`, feedback, {
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
        'access-token': getAccessToken(),
      },
    })
    .then((response) => {
      return response.data as FeedbackResponse;
    });
}
